<template>
  <div >
    <a class="menu" v-on:click="nav('/browser-en')">English</a>
    <h1>{{ msg }}</h1>
    <a class="info">输入的 EOS 账号，即可跳转到绑定的网页地址！</a><br>
    <input class="inputTx"  v-model="accountName" type="text"  placeholder="输入 EOS 主网账号"/><br>
    <a class="error-msg">{{errorMsg}}</a><br>
    <button class="inputBtn" v-on:click="refer()">走你！！</button><br><br>
    <div class="group">
      <a class="info2">
        1. 通过该浏览器，你可以用 EOS 账号访问绑定的网站。
      </a><br>
      <a class="info2">
        2. 你可以通过<a class="href" v-on:click="nav('/')">ENS</a>进行绑定。
      </a>
    </div>
    <br><br>
    <a class="href" v-on:click="nav('/')">[ENS]</a>
    <a href="https://github.com/EOSNameServe/ENS" class="href">[GitHub 项目介绍]</a>
    <a href="https://t.me/EOSNameServe" class="href">[Telegram]</a>
    <a href="https://github.com/EOSNameServe/ensProtocolParser" class="href">[Chrome-Plugin]</a>
    <a href="./agent/x-account.html" class="href">[购买 x 短账号]</a>
    <a href="http://eosnameswaps.com" class="href">[用 eosnameswaps 购买其他账号]</a>
    <a href="http://eoscontract.io" class="href">[用 eoscontract 购买其他账号]</a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'ENS 浏览器',
      accountName:'',
      hasBind: false,
      errorMsg:'',// 错误信息
    }
  },
  methods:{
    refer:function(){
      this.$http.post("https://api1.eosasia.one/v1/chain/get_table_rows",{
        scope:this.accountName,
        code:"enserve.bank",
        table:"enstables",
        json:"true"
      }).then(response => {
        if(response.body.rows.length > 0){
          this.hasBind = true;
          this.bindDappUrl = response.body.rows[0].dapp;
          window.location=this.bindDappUrl;
        } else {
          this.hasBind = false;
          this.errorMsg = "该账户未绑定 URL !";
        }
      }).catch(error => {
        console.log("getId error: " + error);
        alert(JSON.stringify(error));
      });
    },
    nav:function(path) {
        this.$router.push(path);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.group{
  text-align: left;
  width: 20em;
  margin: 0 auto
}
.info{
  color: #333;
}
.info2{
  color: #333;
  size: 6em;
}
.menu {
  cursor:pointer;
  position: fixed;
  right: 0;
  top: 8%;
  width: 6em;
  margin-top: -2.5em;
}
.href{
  cursor:pointer;
  text-decoration: underline;
  margin-top: 100px;
  padding: 10px;
  color: rgb(3, 3, 3);
}
h1, h2 {
  font-weight: normal;
}
.error-msg{
  color: red;
  font-size:8px
}
.inputTx{
  border: 1px solid rgb(75, 75, 75);
  border-radius: 5px;
  padding: 10px;
  width: 240px;
  height: 20px;
  margin-top: 30px;
}
.inputTx:focus{
    border: 2px solid #333;
    outline: none;
}
.inputBtn{
  padding: 10px;
  margin-top: 30px;
  width: 300px;
  border: 1px solid rgb(75, 75, 75);
  border-radius: 5px;
}
.inputBtn:hover{
  background-color: rgb(107, 107, 107);
  color: rgb(255, 255, 255);
}
.inputBtn:focus{
  outline:none;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Browser.vue